export default __webpack_public_path__ + "static/donate-coin-155288ee7d4bbd60b76226c03685d2b4.mp4";